import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { fetchSearchResults, fetchSearchSeriesQuizzes } from '../services/searchService';

export function nextSearchPage(page) {
  return page.currentPage < page.totalPages ? page.currentPage + 1 : undefined;
}

export default function useSearchResults(context, series = false) {
  const { user } = useAuth();
  const language = user?.preferred_lang || user?.content_language || 'EN';
  const query = useInfiniteQuery({
    queryKey: ['searchResults', user?.id || user?.user_id, language, series ? 'series' : 'search', context],
    queryFn: ({ pageParam, signal }) => series
      ? fetchSearchSeriesQuizzes({ ...context, page: pageParam }, { signal })
      : fetchSearchResults({ ...context, page: pageParam }, { signal }),
    initialPageParam: 1,
    getNextPageParam: nextSearchPage,
    enabled: series ? Boolean(context.seriesId && context.stateId) : Boolean(context.keyword),
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  });
  return { ...query, language };
}
